import type { SectionId } from '@/access/sections'

export interface CopyContext {
  condoName: string
  /** Approvals + pending bookings (the overview subtitle). */
  waiting: number
}

/** Page subtitles, final pt-BR copy from the handoff. Titles come from `SECTIONS[].label`. */
export const SUBTITLES: Record<SectionId, (ctx: CopyContext) => string> = {
  overview: ({ condoName, waiting }) =>
    `${condoName} — ${waiting} itens aguardam você nesta manhã.`,
  approvals: () =>
    'Publicações e enquetes dos moradores aguardam aqui até um administrador publicá-las. Conteúdo denunciado continua no ar até você decidir.',
  bookings: () =>
    'Confirme ou recuse solicitações das áreas comuns. Aprovar bloqueia o horário para os demais.',
  desk: () =>
    'Tudo que aguarda uma unidade é uma retirada com um código. Registre a entrega como unidade + transportadora — sem descrições para digitar.',
  residents: () =>
    'Encontre alguém por e-mail, telefone ou CPF e vincule a uma unidade. Vincular concede o escopo de morador neste condomínio.',
  condo: () => 'O que os moradores veem na aba Condomínio.',
  balances: () =>
    'Publique o resultado do mês e anexe o relatório completo. Os moradores veem os totais e abrem o PDF para o detalhamento.',
  staff: () =>
    'Os escopos definem quem pode publicar, moderar e confirmar reservas neste condomínio.',
}
